require('jquery'); // jquery
require('imports!common/support-old-jquery');
require('imports!bootstrap/js/button'); // bootstrap/js/button
require('imports!bootstrap/js/transition'); // bootstrap/js/transition
require('imports!bootstrap/js/collapse'); // bootstrap/js/collapse
require('imports!bootstrap/js/dropdown'); // bootstrap/js/dropdown
require('imports!bootstrap/js/tab'); // bootstrap/js/tab
require('imports!bootstrap/js/modal'); // bootstrap/js/modal
require('guillotine'); // guillotine
// require('swfobject'); // swfobject
require('js-cookie'); // js-cookie
// external dependencies not installed with npm
require('imports!./vendor/jqueryvalidate/jquery.validate-1.11.1.js');// jquery.validate v1.11.1
require('imports!./vendor/jqueryvalidate/jquery.validate.unobtrusive.js'); // jquery.validate vX.X.X
require('imports!./vendor/jqueryajax/jquery.unobtrusive-ajax.js');// jquery.unobtrusive-ajax vX.X.X
require('imports!./vendor/jquerydotdotdot/jquery.dotdotdot.js');// jquery.dotdotdot v1.7.4
require('imports!./vendor/isOnScreen/jquery.isonscreen.js');
require('imports!./vendor/babel-polyfill/polyfill.js');
require('imports!flexslider');// flexslider v2.5.0
// require('imports!jquery-mousewheel');

// custom libs
require('imports!common/jquery.validate.directio.js')(); // jquery.validate.directio



// WEBPACK FOOTER //
// ./Scripts/vendors.js